import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f9228926&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=f9228926&prod&lang=less&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=f9228926&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_css-loader@6.11.0_webpack@5.112.2_cssnano@5_1172e8c895bf55765989039ef5c6f526/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9228926",
  null
  
)

export default component.exports